import style from './P2PResultErrorFeedbackScreen.css';
import ErrorFeedbackScreen from '../../shared/ErrorFeedbackScreen/ErrorFeedbackScreen';
import useTranslation from '../../../localization/i18n.context';
import ErrorRoundImage from '../../../assets/images/error-round.webp';
import NavigationUtils from '../../../utils/navigation.utils';

export default function P2PResultErrorFeedbackScreen({ className = '' }) {
  const { t } = useTranslation();

  return (
    <ErrorFeedbackScreen
      className={`${className} ${style.container}`}
      image={ErrorRoundImage}
      title={t('Ooops!')}
      subtitle={t('Something went wrong')}
      ctaText={t('Try Again')}
      ctaAction={() => NavigationUtils.back()}
      onCloseClick={() => NavigationUtils.endFlow()}
    />
  );
}
